module.exports = __webpack_public_path__ + "media/day/230-d9af1c81.svg";